const workoutExplanationSectionTranslations = {
  generalTutorial: "شرح البرنامج",
  weightsAndRepsSheet: "تسجيل الأوزان والعدات",
  progressiveOverload: "التدرج في الاحمال",
  weight: "الاوزان",
  tempo: "السرعة",
  breathing: "التنفس",
  water: "الماء",
  dailyExercise: "تمرين صباحي يومي",
  dropSet: "كيفية تطبيق التكنيك",
  actionButton: "عرض",
};

export default workoutExplanationSectionTranslations;
